import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MsalService, MSAL_INSTANCE, MsalGuard, MsalInterceptor, MsalBroadcastService } from 'msal';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';

import { NgSelectModule } from '@ng-select/ng-select';
// import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';

import { MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from 'msal/constants';
import { MsalGuardConfiguration } from 'msal/msal.guard.config';
import { MsalInterceptorConfig } from 'msal/msal.interceptor.config';

import { LayoutHeaderComponent } from './layout-header/layout-header.component';
import { LayoutFooterComponent } from './layout-footer/layout-footer.component';
import { LayoutMasterComponent } from './layout-master/layout-master.component';
import { AuthenticationService } from './authentication.service';


let AppInjector: Injector;


function MSALInstanceFactory(): IPublicClientApplication {
  const authConfigService: AuthenticationService = AppInjector.get(AuthenticationService);
  return new PublicClientApplication({
    auth: {
      clientId: authConfigService.authConfiguration.clientId,
      authority: authConfigService.authConfiguration.authority,
      redirectUri: authConfigService.authConfiguration.redirectUri,
      postLogoutRedirectUri: authConfigService.authConfiguration.postLogoutRedirectUri
    },
    cache: {
      cacheLocation: "localStorage"
    },
  });
}

function MSALInterceptorConfigFactory(): MsalInterceptorConfig {
  const authConfigService: AuthenticationService = AppInjector.get(AuthenticationService);
  const protectedResourceMap = authConfigService.protectedResourceMap;
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

@NgModule({
  declarations: [
    LayoutHeaderComponent,
    LayoutFooterComponent,
    LayoutMasterComponent
  ],
  exports: [LayoutMasterComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    // NgOptionHighlightModule,
    // NgOptionHighlightModule,
    FontAwesomeModule,
    NgbModule,
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useValue: {
      interactionType: InteractionType.Redirect
    } as MsalGuardConfiguration
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory
  },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ]
})

export class CoreModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
